import {
  Button,
  Icon,
  Select,
  SelectItem,
  TableCell,
  TableRow,
  TextInput,
} from "@tremor/react";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  DeleteModal,
  RegisterUserAccessAppModal,
  TableComponent,
  TitlePageInfo,
} from "../components";
import { useAPI } from "../../hooks";
import { AlertBox } from "../../ui/";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/solid";
import { useNavigate } from "react-router-dom";

const Form = ({ setIdUser, dataToEdit, isEditMode = false }) => {
  const { post, patch } = useAPI();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      businessName: isEditMode ? dataToEdit.businessName : "",
      city: isEditMode ? dataToEdit.city : "",
      country: isEditMode ? dataToEdit.country : "",
      email: isEditMode ? dataToEdit.email : "",
      name: isEditMode ? dataToEdit.name : "",
      neighborhood: isEditMode ? dataToEdit.neighborhood : "",
      phone: isEditMode ? dataToEdit.phone : "",
      postalCode: isEditMode ? dataToEdit.postalCode : "",
      RFC: isEditMode ? dataToEdit.RFC : "",
      street: isEditMode ? dataToEdit.street : "",
      streetNumber: isEditMode ? dataToEdit.streetNumber : "",
    },
  });

  const onSubmit = async (dataValues) => {
    const dataForm = {
      ...dataValues,
    };
    if (isEditMode) {
      const { data, isSuccess } = await patch(
        `/admin-client/${dataToEdit.id}`,
        dataForm
      );
      if (!isSuccess) return;
      setIdUser(data.data.id);
      navigate("/admin/customers");

      return;
    }
    const { data, isSuccess } = await post("/admin-client", dataForm);
    if (!isSuccess) return;
    setIdUser(data.data.id);
    navigate("/admin/customers");
    return;
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="grid grid-cols-3 gap-2">
        <div>
          <p>Nombre</p>
          <TextInput
            type="text"
            className="w-full"
            placeholder="Juan Pérez"
            name="name"
            {...register("name", {
              required: {
                value: true,
                message: "Debe contener Nombre el perfil",
              },
              minLength: {
                value: 2,
                message: "Debe contener al menos 2 caracteres",
              },
            })}
          />
          {errors?.name && (
            <span className="text-red-500 text-sm italic">
              {errors?.name?.message}
            </span>
          )}
        </div>
        <div className="col-span-2">
          <p>Correo Electrónico</p>
          <TextInput
            type="text"
            placeholder="email@email.com"
            name="email"
            {...register("email", {
              required: {
                value: true,
                message: "Debe contener un correo electrónico",
              },
              pattern: {
                value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                message: "Debe ser un correo electrónico válido",
              },
            })}
          />
          {errors?.email && (
            <span className="text-red-500 text-sm italic">
              {errors?.email?.message}
            </span>
          )}
        </div>
        <div>
          <p>Teléfono</p>
          <TextInput
            type="text"
            placeholder="8100000000"
            name="phone"
            {...register("phone", {
              required: {
                value: false,
                message: "Debe contener un teléfono",
              },
              minLength: {
                value: 10,
                message: "Debe contener al menos 10 caracteres",
              },
              pattern: {
                value: /^[0-9]*$/,
                message: "Debe contener solo números",
              },
            })}
          />
          {errors?.phone && (
            <span className="text-red-500 text-sm italic">
              {errors?.phone?.message}
            </span>
          )}
        </div>
        <div>
          <p>Razón Social</p>
          <TextInput
            type="text"
            placeholder="Razón Social"
            name="businessName"
            {...register("businessName", {
              required: {
                value: true,
                message: "Debe contener una Razón Social",
              },
              minLength: {
                value: 2,
                message: "Debe contener al menos 2 caracteres",
              },
            })}
          />
          {errors?.businessName && (
            <span className="text-red-500 text-sm italic">
              {errors?.businessName?.message}
            </span>
          )}
        </div>
        <div>
          <p>RFC</p>
          <TextInput
            type="text"
            placeholder="RFC"
            name="RFC"
            {...register("RFC", {
              required: {
                value: true,
                message: "Debe contener un RFC",
              },
              minLength: {
                value: 2,
                message: "Debe contener al menos 2 caracteres",
              },
            })}
          />
          {errors?.RFC && (
            <span className="text-red-500 text-sm italic">
              {errors?.RFC?.message}
            </span>
          )}
        </div>
        <div>
          <p>Calle</p>
          <TextInput
            type="text"
            placeholder="Calle"
            name="street"
            {...register("street", {
              required: {
                value: true,
                message: "Debe contener una calle",
              },
              minLength: {
                value: 1,
                message: "Debe contener al menos 1 caracteres",
              },
              pattern: {
                value: /^[a-zA-Z0-9\s]+$/,
                message: "Debe contener solo números y letras",
              },
            })}
          />
          {errors?.street && (
            <span className="text-red-500 text-sm italic">
              {errors?.street?.message}
            </span>
          )}
        </div>
        <div>
          <p>Número de Calle</p>
          <TextInput
            type="text"
            placeholder="124"
            name="streetNumber"
            {...register("streetNumber", {
              required: {
                value: true,
                message: "Debe contener un número de calle",
              },
              minLength: {
                value: 1,
                message: "Debe contener al menos 1 caracteres",
              },
              pattern: {
                value: /^[a-zA-Z0-9]+$/,
                message: "Debe contener solo números y letras",
              },
            })}
          />
          {errors?.streetNumber && (
            <span className="text-red-500 text-sm italic">
              {errors?.streetNumber?.message}
            </span>
          )}
        </div>
        <div>
          <p>Colonia</p>
          <TextInput
            type="text"
            placeholder="Colonia"
            name="neighborhood"
            {...register("neighborhood", {
              required: {
                value: true,
                message: "Debe contener una colonia",
              },
              minLength: {
                value: 1,
                message: "Debe contener al menos 1 caracteres",
              },
            })}
          />
          {errors?.neighborhood && (
            <span className="text-red-500 text-sm italic">
              {errors?.neighborhood?.message}
            </span>
          )}
        </div>
        <div>
          <p>Ciudad</p>
          <TextInput
            type="text"
            placeholder="Monterrey"
            name="city"
            {...register("city", {
              required: {
                value: true,
                message: "Debe contener una ciudad",
              },
              minLength: {
                value: 1,
                message: "Debe contener al menos 1 caracteres",
              },
            })}
          />
          {errors?.city && (
            <span className="text-red-500 text-sm italic">
              {errors?.city?.message}
            </span>
          )}
        </div>
        <div>
          <p>País</p>
          <TextInput
            type="text"
            placeholder="México"
            name="country"
            {...register("country", {
              required: {
                value: true,
                message: "Debe contener un país",
              },
              minLength: {
                value: 1,
                message: "Debe contener al menos 1 caracteres",
              },
            })}
          />
          {errors?.country && (
            <span className="text-red-500 text-sm italic">
              {errors?.country?.message}
            </span>
          )}
        </div>
        <div>
          <p>C.P</p>
          <TextInput
            type="text"
            placeholder="64000"
            name="postalCode"
            {...register("postalCode", {
              required: {
                value: true,
                message: "Debe contener un código postal",
              },
              minLength: {
                value: 1,
                message: "Debe contener al menos 1 caracteres",
              },
              maxLength: {
                value: 5,
                message: "Debe contener máximo 5 caracteres",
              },
              pattern: {
                value: /^[0-9]*$/,
                message: "Debe contener solo números",
              },
            })}
          />
          {errors?.postalCode && (
            <span className="text-red-500 text-sm italic">
              {errors?.postalCode?.message}
            </span>
          )}
        </div>
      </div>
      <div className="flex justify-end mt-2">
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Guardando..." : "Guardar"}
        </Button>
      </div>
    </form>
  );
};

const FormAccessApp = ({ idUser = 0, isEditMode, userToEditApp = null }) => {
  // HACK: address and taxID is only required when isBuyer field is true
  const navigate = useNavigate();
  const { post } = useAPI();
  const {
    name,
    email,
    password,
    cpassword,
    address,
    isBuyer,
    hasAccessApp,
    taxId,
    formState,
    onInputChange,
    isFormValid,
  } = useForm(
    {
      name: "",
      email: "",
      password: "",
      cpassword: "",
      taxId: "",
      address: "",
      isBuyer: false,
      hasAccessApp: false,
      id: 0,
      isEditing: false,
    },
    formValidationsAccessApp
  );

  useEffect(() => {
    if (!isEditMode || !userToEditApp) return;
    const keysUsers = Object.keys(userToEditApp);
    for (let index = 0; index < keysUsers.length; index++) {
      const e = {
        target: {
          name: keysUsers[index],
          value: userToEditApp[keysUsers[index]],
        },
      };
      onInputChange(e);
    }
  }, [userToEditApp]);

  useEffect(() => {
    if (!hasAccessApp && !isEditMode) return;
    const time = new Date();
    const numbersEmail = time.getTime().toString().slice(-4);
    const nameEmail = name.toLowerCase().replaceAll(" ", "_");
    const password = time.getTime().toString().slice(-6);
    const event = {
      target: {
        name: "email",
        value: `${nameEmail}_${numbersEmail}@rm.com`,
      },
    };

    const eventPassword = {
      target: {
        name: "password",
        value: password,
      },
    };

    const eventCPassword = {
      target: {
        name: "cpassword",
        value: password,
      },
    };

    onInputChange(event);
    onInputChange(eventPassword);
    onInputChange(eventCPassword);
  }, [hasAccessApp, name]);

  const handleCheckboxChange = (e) => {
    const event = {
      target: {
        name: "hasAccessApp",
        value: e.target.checked,
      },
    };
    onInputChange(event);
  };

  const handleSelectItem = (value) => {
    const event = {
      target: {
        name: "isBuyer",
        value: value === "true" ? true : false,
      },
    };

    onInputChange(event);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (isBuyer && (taxId.trim().length <= 0 || address.trim().length <= 0)) {
      AlertBox({
        color: "warning",
        messages: ["Debe contenener un tax ID o una Dirección"],
      });
      return;
    }

    const dataForm = {
      ...formState,
      idUser,
    };

    const { data, isSuccess } = await post(
      "/admin-client/app-client",
      dataForm
    );
    if (!isSuccess) return;
    navigate("/admin/customers");
  };
  return (
    <>
      <form onSubmit={onSubmit}>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Select
              placeholder="Seleccionar tipo de Registro"
              onChange={handleSelectItem}
              name="isBuyer"
              value={`${isBuyer}`}
            >
              <SelectItem value="false">Cliente</SelectItem>
              <SelectItem value="true">Comprador</SelectItem>
            </Select>
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="hasAccessApp"
              name="hasAccessApp"
              onChange={handleCheckboxChange}
              checked={hasAccessApp}
            />
            <label htmlFor="hasAccessApp">Accesso a la App</label>
          </div>
          <div className="col-span-2">
            <p>Nombre</p>
            <TextInput
              type="text"
              placeholder="Juan Pérez"
              name="name"
              value={name}
              onChange={onInputChange}
            />
          </div>
          <div className="col-span-2">
            <p>Correo Electrónico</p>
            <TextInput
              type="email"
              placeholder="email@email.com"
              name="email"
              value={email}
              onChange={onInputChange}
            />
          </div>
          <div className="col-span-2">
            <p>Contraseña</p>
            <TextInput
              type="text"
              name="password"
              value={password}
              onChange={onInputChange}
            />
          </div>
          {/* <div>
            <p>Confirmar Contraseña</p>
            <TextInput
              type="password"
              name="cpassword"
              value={cpassword}
              onChange={onInputChange}
            />
          </div> */}
          {isBuyer ? (
            <>
              <div>
                <p>TAX ID</p>
                <TextInput
                  type="text"
                  name="taxId"
                  value={taxId}
                  onChange={onInputChange}
                />
              </div>
              <div>
                <p>Dirección</p>
                <TextInput
                  type="text"
                  name="address"
                  value={address}
                  onChange={onInputChange}
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
        <div className="flex justify-end mt-2">
          <Button type="submit">Guardar Acceso</Button>
        </div>
      </form>
    </>
  );
};

const TableUsersRegistersInApp = ({
  users = [],
  isEditMode = false,
  navigate,
  setUserToEditApp,
  showModal,
}) => {
  const tableContent = users.map((u) => (
    <RowTable
      key={u.id}
      {...u}
      setUserToEditApp={setUserToEditApp}
      showModal={showModal}
      navigate={navigate}
    />
  ));
  return (
    <>
      <TableComponent
        showSearchInput={false}
        showSelectLogs={false}
        title="Usuarios Registrados en la App"
        tableHeaders={["Nombre", "Correo Electrónico", "Comprador/Cliente"]}
        tableContent={tableContent}
      />
    </>
  );
};

const RowTable = ({
  name,
  email,
  isBuyer,
  id,
  password,
  taxId,
  address,
  hasAccessApp,
  setUserToEditApp,
  navigate,
  // showModal,
}) => {
  const { del } = useAPI();
  const [showModal, setModal] = useState(false);

  const goToEdit = () => {
    setUserToEditApp({
      name,
      email,
      isBuyer,
      id,
      password,
      taxId,
      address,
      hasAccessApp,
    });
  };

  const showModalDelete = () => setModal(true);
  const hideModalDelete = () => setModal(false);

  const deleteUser = () => {
    del(`/admin-client/app-client/${id}`);
    hideModalDelete();
    navigate("/admin/customers");
  };

  return (
    <>
      {showModal && (
        <DeleteModal
          information={`${name}`}
          cancelFunction={hideModalDelete}
          confirmFunction={deleteUser}
        />
      )}
      <TableRow>
        <TableCell>{name}</TableCell>
        <TableCell>{email}</TableCell>
        <TableCell>{isBuyer ? "Comprador" : "Cliente"}</TableCell>
        <TableCell>
          <Icon variant="solid" icon={PencilSquareIcon} onClick={goToEdit} />
          <Icon
            variant="solid"
            icon={TrashIcon}
            className="ml-1"
            onClick={showModalDelete}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export const FormCustomerAdminLayout = ({
  isEditMode = false,
  dataToEdit = {},
  titlePage = "",
}) => {
  const navigate = useNavigate();
  const [userToEditApp, setUserToEditApp] = useState(null);
  const [idUser, setIdUser] = useState(0);
  const [showModal, setModal] = useState(false);
  const showModalRegister = () => {
    setModal(true);
  };

  useEffect(() => {
    if (!userToEditApp) return;
    showModalRegister();
  }, [userToEditApp]);

  const hideModalRegister = () => {
    setUserToEditApp(null);
    setModal(false);
    navigate("/admin/customers");
  };

  return (
    <>
      {showModal ? (
        <RegisterUserAccessAppModal
          titlePage="Creación de Credenciales"
          cancelAndGoBack={hideModalRegister}
          userToEditApp={userToEditApp}
          isEditMode={isEditMode}
          idUser={dataToEdit.id}
        />
      ) : (
        <></>
      )}
      <TitlePageInfo title={titlePage} />
      <Form
        isEditMode={isEditMode}
        dataToEdit={dataToEdit}
        setIdUser={setIdUser}
      />

      {isEditMode ? (
        <>
          {/* <FormAccessApp
            idUser={dataToEdit.id}
            userToEditApp={userToEditApp}
            isEditMode={isEditMode}
          /> */}
          <Button className="ml-auto flex my-2" onClick={showModalRegister}>
            Nuevo Acceso
          </Button>
          <TableUsersRegistersInApp
            showModal={showModalRegister}
            users={dataToEdit.usersAccessApp}
            setUserToEditApp={setUserToEditApp}
            navigate={navigate}
          />
        </>
      ) : (
        // <></>
        <></>
      )}
    </>
  );
};

FormCustomerAdminLayout.propTypes = {
  isEditMode: PropTypes.bool,
  dataToEdit: PropTypes.object,
  titlePage: PropTypes.string,
};

Form.propTypes = {
  setIdUser: PropTypes.func,
  dataToEdit: PropTypes.object,
  isEditMode: PropTypes.bool,
};

FormAccessApp.propTypes = {
  idUser: PropTypes.number,
  isEditMode: PropTypes.bool,
  userToEditApp: PropTypes.object,
};

TableUsersRegistersInApp.propTypes = {
  users: PropTypes.array,
  isEditMode: PropTypes.bool,
  setUserToEditApp: PropTypes.func,
  showModal: PropTypes.func,
  navigate: PropTypes.func,
};

RowTable.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  isBuyer: PropTypes.bool,
  id: PropTypes.number,
  password: PropTypes.string,
  taxId: PropTypes.string,
  address: PropTypes.string,
  hasAccessApp: PropTypes.bool,
  setUserToEditApp: PropTypes.func,
  showModal: PropTypes.func,
  navigate: PropTypes.func,
};
